import { watchRequestCatalogs } from './catalogs';

export const catalogsSaga = [
  watchRequestCatalogs,
];
